import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win: any = window
let seriesId: any = ''

if (window.location.href.includes('localhost')) {
  win['isLoggedIn'] = 'false'
  // seriesId = 'watch_series_9_series_da_22022024';
  // seriesId = 'iphone_15_series_da_22022024'
  // seriesId = 'iphone_15_pro_series_da_22022024';
  seriesId = 'iphone_13_pro_max_22022024' //'ipadpro13-inch_da_29022024'; //airpodsmax_da_29022024
  !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080')
  !!!win['store_order_track'] && (win['store_order_track'] = '/wps/portal/web/personal/store/order')
  !!!win['home_page_url'] && (win['home_page_url'] = '/wps/wcm/connect/en/personal')
  !!!win['errorPageURL'] && (win['errorPageURL'] = '/wps/portal/web/personal/store/error')
  !!!win['timeoutPageURL'] && (win['timeoutPageURL'] = '/wps/portal/web/personal/store/timeouterror')
  !!!win['timeoutPageURL'] && (win['timeoutPageURL'] = '/wps/portal/web/personal/store/timeouterror')
  !!!win['cart_app_url'] && (win['cart_app_url'] = '/wps/portal/web/personal/e-commerce/cart')
} else {
  seriesId = new URL(window.location.href).searchParams.get('deviceId');
  const currentURL = window.location.href;
  const hostname = window.location.hostname
  const lang = document.documentElement.lang;
  let cartEndPoint = '/wps/portal/web/personal/e-commerce/cart';

  if (!hostname.includes('mobily.com.sa')) {
    if (currentURL.includes('subsidy')) {
      cartEndPoint = "/wps/portal/web/personal/e-commerce/cart-subsidy";
    }

    if (currentURL.includes('gtm')) {
      cartEndPoint = "/wps/portal/web/personal/e-commerce/cart-gtm";
    }
  }
  win["lang"] = lang === "ar" ? "ar" : "en";
  win['base_portal_url'] = window.location.origin;
  win['store_order_track'] = '/wps/portal/web/personal/store/order';
  win['home_page_url'] = '/wps/wcm/connect/en/personal';
  win['errorPageURL'] = '/wps/portal/web/personal/store/error';
  win['timeoutPageURL'] = '/wps/portal/web/personal/store/timeouterror';
  win['cart_app_url'] = cartEndPoint;
}

const lang = window.location.href.includes('localhost') ? 'en' : document.documentElement.lang
lang === 'ar' ? (document.documentElement.dir = 'rtl') : ''
const rtl = lang === 'ar'
!!!win['lang'] && (win['lang'] = lang)
document.documentElement.lang = lang
const dir = lang === null || lang === 'en' ? 'ltr' : 'rtl'
const deviceTradeUrl = rtl
  ? 'https://mobily.northladder.net/sa-ar/'
  : 'https://mobily.northladder.net/sa-en/'
let homepageEndPoint =
  `/web/${lang === 'ar' ? 'ar' : 'en'}/devices/phones-and-accessories`;
const homePageLink = window.location.origin.includes("localhost")
  ? "http://sdea004:8080/wps/portal/web/personal/e-commerce/phones-and-accessories"
  : window.location.origin + homepageEndPoint;

interface NotifyData {
  mobile: string;
  refId: string;
  email?: string;
}

const initialState = {
  rtl,
  dir,
  lang,
  seriesId,
  xCoId: '',
  deviceFlow: '',
  pageToDisplay: 'ProductDetails',
  subPageToDisplay: 'deviceLogin',
  notifysubPageToDisplay: "notifyMeLogin",
  loading: false,
  filters: [],
  msisdn: '',
  cartId: '',
  scData: {},
  OTPData: {},
  productId: '',
  graphQlResponse: {},
  productData: {},
  encryptedMSISDN: '',
  otpValue: '',
  promotionType: '',
  promotionData: [],
  raqiPromotion: [],
  wajidPromotion: [],
  customerAccount: {},
  promotionApplied: {},
  promoTypeCode: '',
  promoTypeValue: '',
  promoAmount: '',
  promoPeriod: '',
  deviceTradeLink: deviceTradeUrl,
  packageEligibility: {},
  appliedInstallment: {},
  homePageUrl: homePageLink,
  updatedProductPrice: null,
  journeyName: 'Devices_StandAlone',
  orderType: 'Order',
  notifyData: {
    mobile: "",
    email: undefined,
    refId: ""
  }
}

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'LOADER':
      return {
        ...state,
        loading: action.payload.loading,
      }

    case 'XCOID':
      return {
        ...state,
        xCoId: action.payload.xcoid,
      }

    case 'FILTERS_DATA':
      return {
        ...state,
        filters: action.payload.filters,
      }

    case 'PAGE_TO_DISPLAY':
      return {
        ...state,
        pageToDisplay: action.payload.pageToDisplay,
      }

    case 'DEVICE_FLOW':
      return {
        ...state,
        deviceFlow: action.payload.deviceFlow,
      }

    case 'SUB_PAGE_TO_DISPLAY':
      return {
        ...state,
        subPageToDisplay: action.payload.subPageToDisplay,
      }

    case 'DEVICE_MOBILENUMBER':
      return {
        ...state,
        msisdn: action.payload.msisdn,
        encryptedMSISDN: action.payload.encryptedMSISDN,
      }

    case 'SET_SHOPPING_CARTID':
      return {
        ...state,
        cartId: action.payload.cartId,
      }

    case 'SET_SHOPPING_DATA':
      return {
        ...state,
        scData: action.payload.scData,
      }

    case 'INITATE_OTP_DATA':
      return {
        ...state,
        OTPData: action.payload.OTPData,
      }

    case 'CUSTOMER_ACCOUNT_BY_NUMBER':
      return {
        ...state,
        customerAccount: action.payload.customerAccount,
      }

    case 'CAPTURE_OTP_VALUE':
      return {
        ...state,
        otpValue: action.payload.otpValue,
      }

    case 'PRODUCT_VARIANT_ID':
      return {
        ...state,
        productId: action.payload.productId,
      }

    case 'GRAPHQL_RESPONSE_SUCCESS':
      return {
        ...state,
        graphQlResponse: action.payload.graphQlResponse,
      }

    case 'PRODUCT_DATA':
      return {
        ...state,
        productData: action.payload.productData,
      }

    case 'PROMOTIONS_DATA':
      return {
        ...state,
        promotionData: action.payload.promotionData,
      }

    case 'PROMOTION_APPLIED':
      return {
        ...state,
        promotionApplied: action.payload.promotionApplied,
        promoTypeCode: action.payload.promoTypeCode,
        promoTypeValue: action.payload.promoTypeValue,
        promoAmount: action.payload.promoAmount,
        promoPeriod: action.payload.promoPeriod,
      }

    case 'RAQI_PROMOTION':
      return {
        ...state,
        raqiPromotion: action.payload.raqiPromotion,
        promotionType: action.payload.promotionType,
      }

    case 'WAJID_PROMOTION':
      return {
        ...state,
        wajidPromotion: action.payload.wajidPromotion,
        promotionType: action.payload.promotionType,
      }

    case 'INSTALMENT_PACKAGE_ELIGIBILITY':
      return {
        ...state,
        packageEligibility: action.payload.packageEligibility,
      }

    case 'APPLIED_INSTALLMENT':
      return {
        ...state,
        appliedInstallment: action.payload.appliedInstallment,
      }

    case 'SET_UPDATED_PRODUCT_PRICE':
      return {
        ...state,
        updatedProductPrice: action.payload.updatedProductPrice,
      }

    case 'UPDATE_STATE':
      return {
        ...state,
        ...action.payload
      }


    case 'NOTIFY_SUB_PAGE_TO_DISPLAY':
      return {
        ...state,
        notifysubPageToDisplay: action.payload.notifysubPageToDisplay,
      }


    case 'NOTIFY_DATA':
      return {
        ...state,
        notifyData: {
          mobile: action.payload.mobile,
          email: action.payload.email,
          refId: action.payload.refId
        }
      } as NotifyData
    default:
      return state
  }
}

export const GlobalProvider = (props: any) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>{props.children}</GlobalContext.Provider>
  )
}